import React from 'react';
import HandoverPartChecklist from './HandoverPartChecklist';
import { HandoverChecklistItemInput } from '@/services/api/handovers';

interface HandoverFormStep2Props {
  odometer?: string;
  notes: string;
  onOdometerChange: (value: string) => void;
  onNotesChange: (value: string) => void;
  onChecklistChange: (
    items: HandoverChecklistItemInput[],
    isComplete: boolean
  ) => void;
}

const HandoverFormStep2: React.FC<HandoverFormStep2Props> = ({
  odometer,
  notes,
  onOdometerChange,
  onNotesChange,
  onChecklistChange,
}) => {
  return (
    <div>
      <div className="space-y-6">
        {/* Odometer */}
        <div>
          <div className="bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 rounded-md mb-4">
            Odometer
          </div>
          <div className="px-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Odometer at Handover
            </label>
            <div className="flex items-stretch rounded-md border border-gray-300 overflow-hidden">
              <input
                value={odometer || ''}
                onChange={(e) =>
                  onOdometerChange(e.target.value.replace(/\D/g, ''))
                }
                placeholder="e.g. 50,000"
                inputMode="numeric"
                className="w-full px-3 py-2 text-sm focus:outline-none"
              />
              <div className="flex items-center px-3 text-sm text-gray-500 border-l border-gray-200">
                KM
              </div>
            </div>
          </div>
        </div>

        {/* Per-part checklist (equipment presence + photos, body condition) */}
        <HandoverPartChecklist onChange={onChecklistChange} />

        {/* Notes */}
        <div className="px-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notes
          </label>
          <textarea
            value={notes}
            onChange={(e) => onNotesChange(e.target.value)}
            placeholder="e.g. Motor in bekas kecelakaan"
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
          />
          <div className="text-right text-xs text-gray-500 mt-1">
            {notes.length}/200
          </div>
        </div>
      </div>
    </div>
  );
};

export default HandoverFormStep2;
